import { CheckCircle, XCircle } from "lucide-react";

import { cn } from "@/lib/utils";

interface BooleanCellBadgeProps {
  value: boolean | null;
  className?: string;
}

function getBooleanToneClass(value: boolean | null): string {
  if (value === true) {
    return "bg-green-100/80 text-green-700 ring-green-200";
  }
  if (value === false) {
    return "bg-red-100/80 text-red-700 ring-red-200";
  }
  return "bg-muted text-muted-foreground ring-border/70";
}

function getBooleanLabel(value: boolean | null): string {
  if (value === true) {
    return "True";
  }
  if (value === false) {
    return "False";
  }
  return "Unknown";
}

export default function BooleanCellBadge({ value, className }: BooleanCellBadgeProps) {
  let icon = (
    <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground/60" aria-hidden="true" />
  );
  if (value === true) {
    icon = <CheckCircle className="h-4 w-4 text-green-600" />;
  } else if (value === false) {
    icon = <XCircle className="h-4 w-4 text-red-600" />;
  }

  return (
    <span
      role="img"
      aria-label={getBooleanLabel(value)}
      className={cn(
        "inline-flex h-5 w-5 items-center justify-center rounded-full ring-1",
        getBooleanToneClass(value),
        className,
      )}
    >
      {icon}
    </span>
  );
}
